// /buy — one route, two jobs, split on ?order=:
//  - /buy?order=<id>: the checkout view of that order (CheckoutRoute) — a just-created
//    one, or one resumed from /purchases. The id lives in the URL so the view survives
//    a refresh and can be linked to.
//  - /buy, /buy?tier=pro (the desktop app's own upgrade dialog and activation screen open
//    this) and /buy?coupon=CODE: the tier choice (TierChoice), which is what starts a
//    purchase. It reads ?tier= to preselect and ?coupon= to pre-apply.

import { useSearchParams } from "react-router-dom";
import { CheckoutRoute } from "@/pages/buy/Checkout";
import { TierChoice } from "@/pages/buy/TierChoice";

export function Buy() {
  const [params] = useSearchParams();
  const orderId = params.get("order");

  return orderId ? <CheckoutRoute orderId={orderId} /> : <TierChoice />;
}
